module.exports = __webpack_public_path__ + "img/345.f9952568.png";